import { combineReducers } from "@reduxjs/toolkit";
import bankSlice from "./slices/bankSlice";
import bankAccountSlice from "./slices/bankAccountSlice";
import vendorBankAccountSlice from "./slices/vendorBankAccountSlice";
import binSlice from "./slices/binSlice";
import giftCardDetailSlice from "./slices/giftCardDetailSlice";
import giftCardSlice from "./slices/giftCardSlice";
import paymentMethodGroupSlice from "./slices/paymentMethodGroupSlice";
import paymentMethodSlice from "./slices/paymentMethodSlice";
import priceGroupSlice from "./slices/priceGroupSlice";
import termBCSlice from "./slices/termBCSlice";
import voucherDetailSlice from "./slices/voucherDetailSlice";
import voucherSlice from "./slices/voucherSlice";
import voucherTypeSlice from "./slices/voucherTypeSlice";
import bankDepositSlice from "./slices/bankDepositSlice";

export default combineReducers({
  paymentMethod: paymentMethodSlice,
  priceGroup: priceGroupSlice,
  bin: binSlice,
  paymentMethodGroup: paymentMethodGroupSlice,
  giftCard: giftCardSlice,
  giftCardDetail: giftCardDetailSlice,
  bank: bankSlice,
  bankAccount: bankAccountSlice,
  bankDeposit: bankDepositSlice,
  vendorBankAccount: vendorBankAccountSlice,
  voucher: voucherSlice,
  voucherType: voucherTypeSlice,
  voucherDetail: voucherDetailSlice,
  termBC: termBCSlice,
});
